<ng-container *ngIf="showTimer">
    {{ time }}
</ng-container>
